import axios from 'axios';
import history from './history';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
  // baseURL:'https://e81f-2400-7b60-6-4eea-4c96-fb5c-561a-fd46.ngrok-free.app/api'
  // baseURL: 'https://api.swaasa-app.swaasa.ai:8000/api',  //prod
  // baseURL: 'https://api.swaasa-app.swaasa.ai:9000/api',  //prod
  // baseURL: 'https://kas-api.swaasa.ai:8085/api',      //dev
//  baseURL: 'https://kas-api.swaasa.ai:8086/api',      //Testing
// baseURL: "https://4b9e-2401-4900-1cb2-8b4a-7cf1-c551-b617-883.ngrok-free.app/api", //NgRok

});
 instance.defaults.headers.common['ngrok-skip-browser-warning'] = '69420';

// Add a response interceptor to handle 401 errors globally.
instance.interceptors.response.use(
  response => response,
  error => {
    debugger
    if (error.response && error.response.status === 401) {

      localStorage.clear(); // Clear local storage
    history.push("/"); // Redirect to the login page
    }
    return Promise.reject(error);
  }
);
export default instance;
 